var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "factoid",
    class: {
      factoid_qr: _vm.isActive
    }
  }, [_c('h4', {
    staticClass: "factoid__title"
  }, [_vm._v("Загрузите наше приложение")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "factoid__store-socials"
  }, [_c('div', {
    staticClass: "factoid__store factoid__store_google"
  }, [_c('a', {
    staticClass: "factoid__store-link cc-link cc-link_wu fz-17 lh-14",
    attrs: {
      "href": _vm.googlePlayLink,
      "target": "_blank"
    }
  }, [_vm._v("Google Play")])]), _vm._v(" "), _c('div', {
    staticClass: "factoid__store factoid__store_apple"
  }, [_c('a', {
    staticClass: "factoid__store-link cc-link cc-link_wu fz-17 lh-14",
    attrs: {
      "href": _vm.appleStoreLink,
      "target": "_blank"
    }
  }, [_vm._v("App Store")])])]), _vm._v(" "), _c('div', {
    staticClass: "factoid__button factoid__button_desktop"
  }, [_c('button', {
    staticClass: "factoid__button-el",
    on: {
      "click": function ($event) {
        return _vm.onClick();
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.isActive ? "Скрыть" : "Показать") + " QR код\n    ")])]), _vm._v(" "), _c('a', {
    staticClass: "factoid__button factoid__button_mobile cc-link cc-link_wu",
    attrs: {
      "href": _vm.appUniversalLink,
      "target": "_blank"
    }
  }, [_c('button', {
    staticClass: "factoid__button-el"
  }, [_vm._v("Скачать приложение")])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "factoid__list"
  }, [_c('li', {
    staticClass: "factoid__list-item"
  }, [_vm._v("Виртуальная бонусная карта")]), _vm._v(" "), _c('li', {
    staticClass: "factoid__list-item"
  }, [_vm._v("Все акции магазина под рукой")]), _vm._v(" "), _c('li', {
    staticClass: "factoid__list-item"
  }, [_vm._v("Оплачивайте бонусами до 100% покупки")])]);
}]

export { render, staticRenderFns }